export default __webpack_public_path__ + "static/media/Sycamore Icons-07.c73f851e.svg";